export const TOOLTIP_SECTION_LABEL_MAX_WIDTH = 160;
export const TOOLTIP_SECTION_ROW_LINK_TEST_ID = "tooltip-section-row-link";
export const TOOLTIP_SEGMENTED_BAR_HEIGHT = 8;
export const TOOLTIP_SEGMENTED_BAR_TEST_ID = "tooltip-segmented-bar";
